import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User } from '../types';
import {
  User as UserIcon,
  Smile,
  UserCircle,
  Heart,
  Star,
  Coffee,
  Briefcase,
  GraduationCap,
  Shield,
  Crown
} from 'lucide-react';
import './Navbar.css';

const ICON_MAP: Record<string, React.FC<{ size?: number; color?: string }>> = {
  'User': UserIcon,
  'Smile': Smile,
  'UserCircle': UserCircle,
  'Heart': Heart,
  'Star': Star,
  'Coffee': Coffee,
  'Briefcase': Briefcase,
  'GraduationCap': GraduationCap,
  'Shield': Shield,
  'Crown': Crown,
};

interface NavbarProps {
  user: User;
}

const Navbar: React.FC<NavbarProps> = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3010'}/api/auth/logout`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
      }
    } catch (err) {
      console.error('Ошибка при выходе:', err);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      navigate('/login');
    }
  };

  const userName = user.name || user.first_name || user.email || 'U';
  const avatarUrl = user.avatar_url
    ? `${process.env.REACT_APP_API_URL || 'http://localhost:3010'}${user.avatar_url}`
    : null;
  const isIconAvatar = user.avatar_url?.includes('icon=');
  const iconName = isIconAvatar ? user.avatar_url?.split('icon=')[1] : null;
  const IconComponent = iconName ? ICON_MAP[iconName] : null;

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">КАРБИ</Link>
      </div>

      <div className="navbar-actions">
        <Link to="/changelog" className="navbar-btn">
          История обновлений
        </Link>
        <Link to="/profile" className="navbar-btn navbar-btn-profile">
          Профиль
        </Link>
        <button onClick={handleLogout} className="navbar-btn navbar-btn-logout">
          Выйти
        </button>
        <div className="navbar-user">
          {IconComponent ? (
            <div className="navbar-avatar navbar-avatar-icon" style={{ background: user.avatar_color || '#8b5cf6' }}>
              <IconComponent size={20} color="white" />
            </div>
          ) : avatarUrl && !isIconAvatar ? (
            <img src={avatarUrl} alt={userName} className="navbar-avatar" />
          ) : (
            <div className="navbar-avatar navbar-avatar-placeholder" style={{ background: user.avatar_color || '#4F46E5' }}>
              {userName.charAt(0).toUpperCase()}
            </div>
          )}
          <span className="navbar-username">{userName}</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
